import React from 'react'
import { Box, Link } from '@ally/metronome-ui'
import { useWidget } from './WidgetContext'

const WidgetFooter: React.FC = (): React.ReactElement => {
  const { activeAccountId } = useWidget()
  return (
    <Box textAlign="right">
      <Link
        withAllyTM="STK Go to savings account widget"
        text="Go to savings account"
        to={`/bank/accounts/details/${activeAccountId}`}
      />
    </Box>
  )
}

export default WidgetFooter
